export enum SettingsSubpages {
  Connections = "connections",
  ApiKeys = "api-keys",
  OauthClients = "oauth-clients",
  AgentCredentials = "agent-credentials",
  AiUsageLimits = "ai-usage-limits",
  Users = "users",
  UserPermissions = "user-permissions",
  AuditLogs = "audit-logs",
  Powertools = "powertools",
  Sessions = "sessions",
}
